import React, { useState, useEffect } from "react"
import { Row, Col, Card, CardBody } from "reactstrap"
import ReactApexChart from "react-apexcharts"
import API from "../../api/axios"

const MonthlyEarnings = () => {
  const [options, setOptions] = useState({
    colors: ["#28bbe3"],
    chart: {
      toolbar: { show: true },
    },
    dataLabels: { enabled: false },
    plotOptions: {
      bar: {
        columnWidth: "70%",
      },
    },

    //f8f8fa
    grid: {
      borderColor: "#faf8f9ff",
      row: {
        colors: ["transparent", "transparent"],
        opacity: 0.5,
      },
    },
    xaxis: {
      categories: [], // months will be filled from API
      axisBorder: { show: false },
      axisTicks: { show: false },
    },
    yaxis: {
      title: { text: "Revenue ($)" },
    },
    tooltip: {
      y: {
        formatter: (val) => `$${val}`,
      },
    },
    fill: { opacity: 1 },
    legend: { show: false },
  })

  const [series, setSeries] = useState([{ name: "Revenue", data: [] }])
  const [totalRevenue, setTotalRevenue] = useState(0)

  useEffect(() => {
    fetchData()
  }, [])

  const fetchData = async () => {
    try {
      const token = localStorage.getItem("authToken")
      const response = await API.get(
        "/appointments/monthly-revenue",
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )

      const categories = response.data.map((item) => item.month)
      const seriesData = response.data.map((item) =>
        parseFloat(item.totalRevenue)
      )

      const total = seriesData.reduce((a, b) => a + b, 0)

      setOptions((prev) => ({
        ...prev,
        xaxis: { ...prev.xaxis, categories },
      }))
      setSeries([{ name: "Revenue", data: seriesData }])
      setTotalRevenue(total)
    } catch (error) {
      console.error("Error fetching monthly revenue", error)
    }
  }

  return (
    <React.Fragment>
      <Card>
        <CardBody>
          <h4 className="card-title mb-4">Revenue Per Month</h4>

          <Row className="text-center mt-4">
            <Col xs="6">
              <h5 className="font-size-20">${totalRevenue}</h5>
              <p className="text-muted">Total Revenue</p>
            </Col>
            <Col xs="6">
              <h5 className="font-size-20">{series[0].data.length}</h5>
              <p className="text-muted">Months Counted</p>
            </Col>
          </Row>

          <div id="monthly-revenue-chart" className="apex-charts" dir="ltr">
            <ReactApexChart
              options={options}
              series={series}
              type="bar"
              height="290"
            />
          </div>
        </CardBody>
      </Card>
    </React.Fragment>
  )
}

export default MonthlyEarnings
